import { combineReducers } from "@reduxjs/toolkit";

import {
	globalStateExecutorRatingDataState,
	globalStateExecutorRatingDataReducer,
	globalStateExecutorRatingDataAction,
} from "./data";

export type StateExecutorRating = {
	data: globalStateExecutorRatingDataState;
};

export const executorRating = combineReducers<StateExecutorRating>({
	data: globalStateExecutorRatingDataReducer,
});

export const globalStateExecutorRatingAction = {
	data: globalStateExecutorRatingDataAction,
};

export default executorRating;
